import { CampaignAdGroupGeoLocation } from '../types/Campaign';

const CampaignAdGroupGeoLocationUtils = {
    toDspGeoLocationIds: (targets: CampaignAdGroupGeoLocation[]): string[] => {
        return targets?.map((target: CampaignAdGroupGeoLocation) => target.dspGeoLocationId) || [];
    },
};

export default CampaignAdGroupGeoLocationUtils;
